import React, {
    useState,
    useEffect
} from "react";

import {
    useNavigate
} from "react-router-dom";

import {
    useAuth
} from "../../contexts/AuthContext";

import {
    loadDraft,
    createDraft,
    updateDraft,
    completeDraft
} from "../services/brandOnboarding";

import WizardProgress from "./WizardProgress";
import WizardNavigation from "./WizardNavigation";

import BrandStep1 from "./BrandStep1";
import BrandStep2 from "./BrandStep2";
import BrandStep3 from "./BrandStep3";
import BrandStep4 from "./BrandStep4";
import BrandStep5 from "./BrandStep5";

export default function BrandSetupWizard({

    existingBrand = null,

    onFinished

}) {

    const navigate = useNavigate();

    const { user } = useAuth();

    const STORAGE_KEY = user
        ? `brandWizard_${user.id}`
        : "brandWizard_guest";

    const [step, setStep] = useState(1);

    const [saving, setSaving] = useState(false);

    const [draftBrand, setDraftBrand] = useState(null);

    const [form, setForm] = useState({

        /* -------------------------------- */
        /* STEP 1                           */
        /* -------------------------------- */

        brandName: existingBrand?.brandName || "",

        businessType: existingBrand?.businessType || "",

        category: existingBrand?.category || "",

        tagline: existingBrand?.tagline || "",

        logo: null,

        /* -------------------------------- */
        /* STEP 2                           */
        /* -------------------------------- */

        ownerName: existingBrand?.ownerName || "",

        email: existingBrand?.email || "",

        phone: existingBrand?.phone || "",

        website: existingBrand?.website || "",

        address: existingBrand?.address || "",

        /* -------------------------------- */
        /* STEP 3                           */
        /* -------------------------------- */

        description: existingBrand?.description || "",

        mission: existingBrand?.mission || "",

        vision: existingBrand?.vision || "",

        foundedYear: existingBrand?.foundedYear || "",

        /* -------------------------------- */
        /* STEP 4                           */
        /* -------------------------------- */

        currency: existingBrand?.currency || "INR",

        timezone: existingBrand?.timezone || "Asia/Kolkata",

        language: existingBrand?.language || "English",

        /* -------------------------------- */
        /* STEP 5                           */
        /* -------------------------------- */

        marketplaceEnabled: true,

        bookingsEnabled: true,

        inventoryEnabled: true,

        crmEnabled: true,

        marketingEnabled: true,

        supportEnabled: true,

        productsEnabled: true,

        servicesEnabled: true,

        ordersEnabled: true,

        paymentsEnabled: true,

        shippingEnabled: true

    });

    /* ==========================================
   Restore Draft From PocketBase
========================================== */

useEffect(() => {

    if (!user) return;

    async function restoreDraft() {

        const draft = await loadDraft(user.id);

        if (!draft) return;

        setDraftBrand(draft);

        setForm(prev => ({

            ...prev,

            ...draft

        }));

        setStep(

            draft.onboardingStep || 1

        );

    }

    restoreDraft();

}, [user]);

   

    /* ==========================================
       Update Field
    ========================================== */

    const updateField = (field, value) => {

        setForm(prev => ({

            ...prev,

            [field]: value

        }));

    };

    /* ==========================================
       Validation
    ========================================== */

    const validateCurrentStep = () => {

        switch (step) {

            case 1:

                return (

                    form.brandName.trim() &&

                    form.businessType.trim() &&

                    form.category.trim()

                );

            case 2:

                return (

                    form.ownerName.trim() &&

                    form.email.trim() &&

                    form.phone.trim()

                );

            case 3:

                return (

                    form.description.trim()

                );

            case 4:

                return true;

            case 5:

                return true;

            default:

                return true;

        }

    };

    /* ==========================================
       Next
    ========================================== */

    const next = () => {

        if (!validateCurrentStep()) {

            alert("Please complete this step.");

            return;

        }

        const newStep = Math.min(5, step + 1);

setStep(newStep);

saveDraft(newStep);

    };

    /* ==========================================
       Previous
    ========================================== */

    const previous = () => {

        setStep(prev => Math.max(1, prev - 1));

    };



const saveDraft = async (currentStep) => {

    if (!user) return;

    try {

        if (draftBrand) {

            const updated = await updateDraft(

                draftBrand.id,

                form,

                currentStep

            );

            setDraftBrand(updated);

        }

        else {

            const created = await createDraft(

                user.id,

                {

                    ...form,

                    onboardingStep: currentStep

                }

            );

            setDraftBrand(created);

        }

    }

    catch (err) {

    console.error("PocketBase Error:");

    console.log(err);

    console.log(err.response);

    console.log(JSON.stringify(err.response?.data, null, 2));

 }

};

    /* ==========================================
       Finish Wizard
    ========================================== */

    const finish = async () => {

        if (!user) {

            alert("Please login first.");

            return;

        }

        try {

            setSaving(true);

            const data = new FormData();

            /* ---------- Owner ---------- */

            data.append("owner", user.id);

            /* ---------- Step 1 ---------- */

            data.append("brandName", form.brandName);

            data.append("businessType", form.businessType);

            data.append("category", form.category);

            data.append("tagline", form.tagline);

            if (form.logo instanceof File) {

                data.append("logo", form.logo);

            }

            /* ---------- Step 2 ---------- */

            data.append("ownerName", form.ownerName);

            data.append("email", form.email);

            data.append("phone", form.phone);

            data.append("website", form.website);

            data.append("address", form.address);

            /* ---------- Step 3 ---------- */

            data.append("description", form.description);

            data.append("mission", form.mission);

            data.append("vision", form.vision);

            data.append("foundedYear", form.foundedYear);

            /* ---------- Step 4 ---------- */

            data.append("currency", form.currency);

            data.append("timezone", form.timezone);

            data.append("language", form.language);

            /* ---------- Step 5 ---------- */

            data.append(

                "marketplaceEnabled",

                form.marketplaceEnabled

            );

            data.append(

                "bookingsEnabled",

                form.bookingsEnabled

            );

            data.append(

                "inventoryEnabled",

                form.inventoryEnabled

            );

            data.append(

                "crmEnabled",

                form.crmEnabled

            );

            data.append(

                "marketingEnabled",

                form.marketingEnabled

            );

            data.append(

                "supportEnabled",

                form.supportEnabled

            );

            data.append(

                "productsEnabled",

                form.productsEnabled

            );

            data.append(

                "servicesEnabled",

                form.servicesEnabled

            );

            data.append(

                "ordersEnabled",

                form.ordersEnabled

            );

            data.append(

                "paymentsEnabled",

                form.paymentsEnabled

            );

            data.append(

                "shippingEnabled",

                form.shippingEnabled

            );

            let savedBrand;

if (draftBrand) {

    savedBrand = await completeDraft(

        draftBrand.id,

        form

    );

}
else if (existingBrand) {

    savedBrand = await completeDraft(

        existingBrand.id,

        form

    );

}
else {

    const created = await createDraft(

        user.id,

        form

    );

    savedBrand = await completeDraft(

        created.id,

        form

    );

}

            

            /* ---------- Notify Parent ---------- */

            if (onFinished) {

                onFinished(savedBrand);

            }

            /* ---------- Redirect ---------- */

            navigate("/brand");

        }

        catch (err) {

            console.error(

                "Brand creation failed:",

                err

            );

            alert(

                err?.message ||

                "Unable to save your brand."

            );

        }

        finally {

            setSaving(false);

        }

    };

    return (

        <div
            style={{
                minHeight: "100vh",
                background: "#f7f8fc",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 40
            }}
        >

            <div
                style={{
                    width: "100%",
                    maxWidth: 900,
                    background: "#fff",
                    borderRadius: 18,
                    padding: 35,
                    boxShadow: "0 15px 45px rgba(0,0,0,.08)"
                }}
            >

                <h1
                    style={{
                        marginBottom: 8
                    }}
                >
                    Build Your Brand
                </h1>

                <p
                    style={{
                        color: "#777",
                        marginBottom: 30
                    }}
                >
                    Let's set up your business on myFAVV Marketplace.
                </p>

                <WizardProgress

                    step={step}

                    total={5}

                />

                <div
                    style={{
                        marginTop: 35,
                        marginBottom: 35
                    }}
                >

                    {step === 1 && (

                        <BrandStep1

                            form={form}

                            updateField={updateField}

                        />

                    )}

                    {step === 2 && (

                        <BrandStep2

                            form={form}

                            updateField={updateField}

                        />

                    )}

                    {step === 3 && (

                        <BrandStep3

                            form={form}

                            updateField={updateField}

                        />

                    )}

                    {step === 4 && (

                        <BrandStep4

                            form={form}

                            updateField={updateField}

                        />

                    )}

                    {step === 5 && (

                        <BrandStep5

                            form={form}

                            updateField={updateField}

                        />

                    )}

                </div>

                <WizardNavigation

                    step={step}

                    total={5}

                    saving={saving}

                    onBack={previous}

                    onNext={next}

                    onFinish={finish}

                />

            </div>

        </div>

    );

}